import React from 'react'
import { startOfDay } from 'date-fns'

import TaskWidget from '@SonarCX/components/molecules/TaskWidget'
import TaskRow from '../TaskRow'
import Information from '../Information'

import useDashboardTasks from '../../hooks/useDashboardTasks'
import useStyles from './styles'

type OverdueProps = {
  mineOnly: boolean
}

const Overdue: React.FC<OverdueProps> = ({ mineOnly }) => {
  const { getKey, formatTasks } = useDashboardTasks({
    mineOnly,
    dateRangeStart: new Date(0),
    dateRangeEnd: startOfDay(new Date())
  })

  const classes = useStyles()

  return (
    <TaskWidget
      title='Overdue'
      getKey={getKey}
      format={formatTasks}
      rowRenderer={TaskRow}
      noTasksText='No overdue tasks'
      className={classes.title}
      infoComponent={
        <Information info='Uncompleted tasks that were due before the start of today' />
      }
    />
  )
}

export default Overdue
